import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

import { NotificationService } from '@core/services/notification/notification';
import { PlatformService } from '@core/services/platform/platform';

@Component({
  selector: 'yt-in-app-notification',
  templateUrl: './in-app-notification.html',
  styleUrls: ['./in-app-notification.scss'],
  imports: [IonIcon, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InAppNotification {
  private readonly notificationService = inject(NotificationService);
  private readonly platformService = inject(PlatformService);

  protected readonly foregroundNotification = this.notificationService.foregroundNotification;
  protected readonly isAndroid = this.platformService.isAndroid;

  constructor() {
    addIcons({ closeOutline });
  }

  handleNotificationClick() {
    const foregroundNotification = this.foregroundNotification();
    if (foregroundNotification) {
      this.notificationService.handleNotification(foregroundNotification);
    }
  }

  clearNotification() {
    this.notificationService.clearForegroundNotification();
  }
}
